import { useState } from 'react';

import PrimaryButton from '../../../components/UI/Buttons/PrimaryButton';
import CustomTextField from '../../../components/UI/Inputs/CustomTextField';
import Modal from '../../../components/UI/Modals/Modal';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Html5QrcodePlugin from '../Html5QrcodePlugin';
import classes from './ScanSampleModal.module.css';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  scan: boolean;
  apiStatus: string;
  sampleBarcode: string;
  onChangeSampleBarcode: any;
  scanDisabled: boolean;
  onSuccessScan: any;
};

const ScanSampleModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  scan,
  apiStatus,
  sampleBarcode,
  onChangeSampleBarcode,
  scanDisabled,
  onSuccessScan,
}) => {
  const [isManuallyEntering, setIsManuallyEntering] = useState<boolean>(false);
  const { translations } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={title}
      containerPadding={'80px 10px 10px 10px'}
    >
      <div className={classes.container}>
        {!isManuallyEntering && scan && isOpen && !scanDisabled && (
          <div className={classes.scanContainer}>
            <Html5QrcodePlugin
              className={classes.scan}
              fps={10}
              qrbox={250}
              disableFlip={false}
              qrCodeSuccessCallback={(decodedText: any, decodedResult: any) => {
                onSuccessScan(decodedText, decodedResult);
              }}
            />
          </div>
        )}
        {isManuallyEntering && (
          <div className={classes.manualContainer}>
            <CustomTextField
              label={translations('sample.barcode').toString()}
              value={sampleBarcode}
              onChange={onChangeSampleBarcode}
            />
          </div>
        )}
        {apiStatus === 'pending' ? (
          <Spinner />
        ) : (
          <div className={classes.actionsContainer}>
            {!isManuallyEntering ? (
              <PrimaryButton
                onClick={() => setIsManuallyEntering(true)}
                text={translations('enter.manually')}
                disabled={false}
                containerStyle={{}}
              />
            ) : (
              <PrimaryButton
                onClick={onConfirm}
                text={translations('button.confirm')}
                disabled={false}
                containerStyle={{ minWidth: '150px', width: '150px' }}
              />
            )}
            <PrimaryButton
              onClick={onClose}
              text={translations('button.cancel')}
              disabled={false}
              containerStyle={{ minWidth: '150px', width: '150px' }}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ScanSampleModal;
